import Page from '@/components/Page';
import PageLayout from '@/components/PageLayout';
import GameSubNav from '@/components/subNavs/GameSubNav';
import { GamesRecapQuery, GamesRecapQueryVariables } from 'queries';
import { entryPoint } from 'react_rails/entryPoint';
import GameArticle from '@/components/GameArticle';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import useScreenSize from 'hooks/useScreenSize';
import StnVideoAd from '@/components/ads/StnVideoAd';
import OutbrainAd from '@/components/ads/OutbrainAd';

export default entryPoint(function Recap({ query: { game } }: { query: GamesRecapQuery; variables: GamesRecapQueryVariables }) {
  if (!game.gameRecap) throw 'gameRecap not found!'; // this is just for TS
  const { isSmallScreen } = useScreenSize();

  return (
    <Page subNav={<GameSubNav game={game} />}>
      <PageLayout>
        {!isSmallScreen && (
          <div style={{ width: '100%' }}>
            <StnVideoAd placement="INLINE" />
          </div>
        )}
        <GameArticle {...game} {...game.gameRecap} />
        <div style={{ width: '100%' }}>
          <MinuteMediaAd placement="IN_FEED" />
        </div>
        <OutbrainAd />
      </PageLayout>
    </Page>
  );
});
